import { clsx } from 'clsx';

export type ButtonVariant = 'primary' | 'glass' | 'outline' | 'ghost' | 'icon' | 'whatsapp';
export type ButtonSize = 'sm' | 'md' | 'lg';

export interface ButtonClassOptions {
  variant?: ButtonVariant;
  size?: ButtonSize;
  /** Round, icon-only shape: 44 px (56 px with `size="lg"`). Implied by `icon` and `whatsapp`. */
  round?: boolean;
  className?: string | undefined;
}

/**
 * Class string for the Button look — also usable on its own for links that must look like buttons
 * when `<Button asChild>` is not convenient. Styles live in `styles/components/controls.css`.
 */
export function buttonClasses({
  variant = 'primary',
  size = 'md',
  round = variant === 'icon' || variant === 'whatsapp',
  className,
}: ButtonClassOptions = {}): string {
  return clsx(
    'btn',
    `btn--${variant}`,
    size !== 'md' && `btn--${size}`,
    round && 'btn--round',
    className,
  );
}
